import { Carousel, Modal } from "antd";
import React from "react";
import { IconClose } from "../../images";
import "./style.scss";

const ProductImagesPreviewModal = (props: any) => {
  const { visible, handleClose, listPreviewImg } = props;

  const showListPreviewImg = (listImg: string[]) =>
    listImg.map((item: string, i: number) => (
      <div key={`gift-${i}`} className="product-gift-slider-item">
        <img src={item} alt="" />
      </div>
    ));

  if (!listPreviewImg || !listPreviewImg.length) {
    return null;
  }

  return (
    <Modal
      title=""
      onCancel={handleClose}
      visible={visible}
      footer={null}
      width="1000px"
      closeIcon={<img src={IconClose} />}
      className="product-images-preview-modal">
      <Carousel autoplay className="product-images-slider">
        {showListPreviewImg(listPreviewImg)}
      </Carousel>
    </Modal>
  );
};

export default ProductImagesPreviewModal;
